import { useRef } from 'react';

export const usePrevious = value => {
  const ref = useRef(value);
  // Intentional ref reads/writes during render: synchronous capture of the previous value
  // makes it safe to drive setState at call sites without causing infinite loops.
  // eslint-disable-next-line react-hooks/refs
  const prev = ref.current;
  // eslint-disable-next-line react-hooks/refs
  ref.current = value;
  return prev;
};
